import React from "react";

const PoolSvg = () => {
  return (
    <svg
      width="12"
      height="9"
      viewBox="0 0 12 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Pool</title>
      <path
        d="M0.333328 8.83332V7.83332H11.6667V8.83332H0.333328ZM0.333328 6.27566V5.27566H11.6667V6.27566H0.333328ZM0.333328 3.72432V2.72432H11.6667V3.72432H0.333328ZM0.333328 1.16666V0.166656H11.6667V1.16666H0.333328Z"
        fill="#5663F2"
      />
    </svg>
  );
};

export default PoolSvg;
